import { geoPath, geoAlbersUsa } from 'd3-geo';

export default function scaleProjection(geometry, width, height) {
  const projection = geoAlbersUsa().scale(1).translate([0, 0]);
  const path = geoPath().projection(projection);
  const b = path.bounds(geometry);
  const s = .95 / Math.max((b[1][0] - b[0][0]) / width, (b[1][1] - b[0][1]) / height);
  const t = [(width - s * (b[1][0] + b[0][0])) / 2, (height - s * (b[1][1] + b[0][1])) / 2];
  projection.scale(s).translate(t);
  path.projection(projection);
  return { path, projection };
};